import { useMsalAuthentication as realUseMsalAuthentication } from "@azure/msal-react";

const useMockMsalAuthentication = () => ({ result: null, error: null });

export const useMsalAuthentication = process.env[
  "REACT_APP_MOCK_FOR_INTEGRATION"
]
  ? useMockMsalAuthentication
  : realUseMsalAuthentication;
